// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/help(.:format)`
 * - Path helper: `help_path`
 * - URL helper: `help_url`
 * - controller#action: `help#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpPath = /*#__PURE__*/ (...args) => {
  const _organizationHelpPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _helpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHelpPath(gon.current_organization.path, ...args);
  }

  return _helpPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/help/shortcuts(.:format)`
 * - Path helper: `help_shortcuts_path`
 * - URL helper: `help_shortcuts_url`
 * - controller#action: `help#shortcuts`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpShortcutsPath = /*#__PURE__*/ (...args) => {
  const _organizationHelpShortcutsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"shortcuts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _helpShortcutsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"shortcuts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHelpShortcutsPath(gon.current_organization.path, ...args);
  }

  return _helpShortcutsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/help/instance_configuration(.:format)`
 * - Path helper: `help_instance_configuration_path`
 * - URL helper: `help_instance_configuration_url`
 * - controller#action: `help#instance_configuration`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpInstanceConfigurationPath = /*#__PURE__*/ (...args) => {
  const _organizationHelpInstanceConfigurationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"instance_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _helpInstanceConfigurationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"instance_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHelpInstanceConfigurationPath(gon.current_organization.path, ...args);
  }

  return _helpInstanceConfigurationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/help/docs(.:format)`
 * - Path helper: `help_docs_path`
 * - URL helper: `help_docs_url`
 * - controller#action: `help#redirect_to_docs`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpDocsPath = /*#__PURE__*/ (...args) => {
  const _organizationHelpDocsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _helpDocsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHelpDocsPath(gon.current_organization.path, ...args);
  }

  return _helpDocsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/help/*path(.:format)`
 * - Path helper: `help_page_path`
 * - URL helper: `help_page_url`
 * - controller#action: `help#show`
 *
 * @param {any} path
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpPagePath = /*#__PURE__*/ (...args) => {
  const _organizationHelpPagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _helpPagePath = /*#__PURE__*/ __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationHelpPagePath(gon.current_organization.path, ...args);
  }

  return _helpPagePath(...args);
};

